import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("unigr_user");
    return u ? JSON.parse(u) : null;
  });
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("unigr_token");
    if (!token) return;
    setChecking(true);
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("unigr_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("unigr_token");
        localStorage.removeItem("unigr_user");
        setUser(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // MFA flow — caller will handle the next step
    if (data?.mfa_required) {
      return data;
    }
    localStorage.setItem("unigr_token", data.token);
    localStorage.setItem("unigr_user", JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const finishMfa = (data) => {
    localStorage.setItem("unigr_token", data.token);
    localStorage.setItem("unigr_user", JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("unigr_token");
    localStorage.removeItem("unigr_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, finishMfa, logout, checking }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
